import type { LayoutBlock } from "../blocks/instance.schema";
import { refineLayout } from "../blocks/rules";
import type { Region } from "../blocks/defs/regions";
import { LayoutV1BaseSchema } from "./LayoutBase.schema";

type RegionsV1 = Record<Region, LayoutBlock[]>;

export const LayoutV1Schema = LayoutV1BaseSchema.superRefine((val, ctx) => {
  const regions: RegionsV1 = {
    topBar: val.regions.topBar,
    leftBar: val.regions.leftBar,
    leftDrawer: val.regions.leftDrawer,
    rightBar: val.regions.rightBar,
    rightDrawer: val.regions.rightDrawer,
    bottomBar: val.regions.bottomBar,
    bottomDrawer: val.regions.bottomDrawer,
    main: val.regions.main,
    modal: val.regions.modal,
  };
  refineLayout(regions, ctx);
});
